import * as regionApi from '../common/api/region';
import { NOT_FOUND, INTERNAL_SERVER_ERROR } from './status';
import sanitizeArticleHTML from '../utils/sanitizeArticleHTML';

export const CLEAR_SUBREGION_OVERVIEW_DATA = 'CLEAR_SUBREGION_OVERVIEW_DATA';
export const FETCH_SUBREGION_OVERVIEW_DATA = 'FETCH_SUBREGION_OVERVIEW_DATA';
export const FETCH_SUBREGION_OVERVIEW_DATA_SUCCESS = 'FETCH_SUBREGION_OVERVIEW_DATA_SUCCESS';

export const FETCH_REGIONAL_ARTICLES = 'FETCH_REGIONAL_ARTICLES';
export const FETCH_REGIONAL_ARTICLES_SUCCESS = 'FETCH_REGIONAL_ARTICLES_SUCCESS';
export const FETCH_REGIONAL_ARTICLES_FAILURE = 'FETCH_REGIONAL_ARTICLES_FAILURE';

export const fetchOverviewData = (subregionId, cookies) => async dispatch => {
  dispatch({
    type: FETCH_SUBREGION_OVERVIEW_DATA,
    subregionId,
  });

  if (!subregionId) {
    dispatch({
      type: NOT_FOUND,
      message: 'The Regional Forecast Overview could not be found',
    });
  }

  try {
    const overview = await regionApi.fetchRegionalOverview(subregionId, cookies);

    dispatch({
      type: FETCH_SUBREGION_OVERVIEW_DATA_SUCCESS,
      subregionId,
      overview,
    });
  } catch (err) {
    if (400 <= err.statusCode && err.statusCode < 500) {
      dispatch({
        type: NOT_FOUND,
        message: 'The Regional Forecast Overview could not be found',
      });
    } else {
      dispatch({
        type: INTERNAL_SERVER_ERROR,
        message: 'The server could not return the Regional Forecast Overview',
      });
    }
  }
};

export const clearOverviewData = () => ({
  type: CLEAR_SUBREGION_OVERVIEW_DATA,
});

export const fetchRegionalArticles = (subregionId, cookies) => async dispatch => {
  dispatch({
    type: FETCH_REGIONAL_ARTICLES,
  });

  try {
    const { data } = await regionApi.fetchRegionalArticles(subregionId, cookies);
    const sanitizedArticles = data.regional.map(article => ({
      ...article,
      content: {
        ...article.content,
        body: sanitizeArticleHTML(article.content.body),
      },
    }));
    dispatch({
      type: FETCH_REGIONAL_ARTICLES_SUCCESS,
      articles: sanitizedArticles,
    });
  } catch (error) {
    dispatch({
      type: FETCH_REGIONAL_ARTICLES_FAILURE,
      error,
    });
  }
};

export const FETCH_NEARBY_SUBREGIONS = 'FETCH_NEARBY_SUBREGIONS';
export const FETCH_NEARBY_SUBREGIONS_SUCCESS = 'FETCH_NEARBY_SUBREGIONS_SUCCESS';
export const FETCH_NEARBY_SUBREGIONS_FAILURE = 'FETCH_NEARBY_SUBREGIONS_FAILURE';

export const fetchNearbySubregions = (subregionId, cookies) => async dispatch => {
  dispatch({ type: FETCH_NEARBY_SUBREGIONS });
  try {
    const nearbySubregions = await regionApi.fetchNearbySubregions(subregionId, cookies);
    dispatch({
      type: FETCH_NEARBY_SUBREGIONS_SUCCESS,
      nearbySubregions,
    });
  } catch (err) {
    dispatch({
      type: FETCH_NEARBY_SUBREGIONS_FAILURE,
      error: err,
    });
  }
};
